import { PublicClientApplication } from '@azure/msal-browser';
import { configuration } from '../constants/auth';

const pca = new PublicClientApplication(configuration);

await pca.initialize();

export default pca;
